import { getRequestLanguages, mapPlatform, mapToApiPlatform } from 'utils';

export const prepareStreamParams = (stream, filters) => {
  const platform =
    stream.params.platforms.length > 1
      ? 'multiPlatform'
      : stream.params.platforms[0];

  const currentFilters = filters[platform];

  const subCategories = Object.values(
    currentFilters?.contentCategoryFilter?.selectedCategories || {}
  );

  const filterParams = {
    langs: getRequestLanguages(currentFilters),
    content_tag_ids: currentFilters?.contentTagFilter?.selectedIds ?? undefined,
    extracted_phrases:
      currentFilters?.wordCloudFilter?.selectedIds ?? undefined,
    extracted_hashtags:
      currentFilters?.hashtagCloudFilter?.selectedIds ?? undefined,
    //sentiment: telegram, twitter, instagram, instagramComment
    sentiments: Object.keys(
      currentFilters?.sentimentFilter?.selectedValues || {}
    ).filter(
      (sentiment) =>
        currentFilters?.sentimentFilter?.selectedValues[sentiment] !== false
    ),
    //advert_noise: instagram
    // min_advert_noise:
    //   platformFilters?.advertFilter?.selectedObjectValues?.min ?? undefined,
    // max_advert_noise:
    //   platformFilters?.advertFilter?.selectedObjectValues?.max ?? undefined,
    //relation_influence: twitter, telegram, news, instagram
    resource_influence_categories: currentFilters?.contentBasedFilter
      ?.selectedObjects?.influenceRate?.active
      ? currentFilters?.contentBasedFilter?.selectedObjects?.influenceRate
          .selectedIds
      : undefined,
    //view: telegram
    min_view:
      currentFilters?.contentBasedFilter?.selectedObjects?.view?.min ??
      undefined,
    max_view:
      currentFilters?.contentBasedFilter?.selectedObjects?.view?.max ??
      undefined,
    //lik: twitter, instagram
    min_like:
      currentFilters?.contentBasedFilter?.selectedObjects?.like?.min ??
      undefined,
    max_like:
      currentFilters?.contentBasedFilter?.selectedObjects?.like?.max ??
      undefined,
    //reaction: virasty (has no likes, sends reactions instead)
    min_reactions:
      currentFilters?.contentBasedFilter?.selectedObjects?.reaction?.min ??
      undefined,
    max_reactions:
      currentFilters?.contentBasedFilter?.selectedObjects?.reaction?.max ??
      undefined,
    //copy: twitter, virasty
    min_copy:
      currentFilters?.contentBasedFilter?.selectedObjects?.copy?.min ??
      undefined,
    max_copy:
      currentFilters?.contentBasedFilter?.selectedObjects?.copy?.max ??
      undefined,
    //comment: instagram
    min_comment:
      currentFilters?.contentBasedFilter?.selectedObjects?.comment?.min ??
      undefined,
    max_comment:
      currentFilters?.contentBasedFilter?.selectedObjects?.comment?.max ??
      undefined,
    //source: twitter, telegram, news
    // source:
    //   platformFilters?.contentTypeFilter?.selectedValue === 'both'
    //     ? undefined
    //     : platformFilters?.contentTypeFilter?.selectedValue,
    //categories: twitter, telegram, news, instagram
    categories:
      Object.keys(
        currentFilters?.contentCategoryFilter?.selectedCategories || {}
      ) || undefined,
    sub_categories:
      subCategories?.length > 0 ? subCategories?.flat(1) : undefined,
    //resource_categories: newspaper
    // resource_categories:
    //   platformFilters?.subjectFilter?.selectedIds ?? undefined,
    [currentFilters?.resourcesFilter?.selectedValue === 'include'
      ? 'resource_ids'
      : 'not_resource_ids']: Object.keys(
      currentFilters?.resourcesFilter?.selectedItems || {}
    ),
    //tag_id/not_tag_id: news, twitter, telegram, newspaper, instagram, instagramComment
    [currentFilters?.resourceCategoryFilter?.filterType === 'include'
      ? 'tag_id'
      : 'not_tag_id']:
      currentFilters?.resourceCategoryFilter?.selectedValue || undefined,
    post_resource_ids: Object.keys(
      currentFilters?.resourcesFilter?.selectedItems || {}
    ),
    //age: twitter, instagram
    m3_age: currentFilters?.ageFilter?.selectedIds ?? undefined,
    gender: currentFilters?.genderFilter?.selectedIds ?? undefined,
  };

  if (platform === 'news') {
    filterParams.media_types =
      currentFilters?.resourceTypeFilter?.selectedIds ?? undefined;
    filterParams.resource_countries =
      currentFilters?.countryFilter?.selectedIds?.length > 0
        ? currentFilters?.countryFilter?.selectedIds
        : undefined;
    filterParams.smart_highlight = 1;
  } else {
    filterParams.media_types =
      currentFilters?.mediaTypeFilter?.selectedIds ?? undefined;
  }

  const params = {
    title: stream.title,
    type: stream.type,
    filter_type: stream.filterType,
    params: {
      api_path: mapPlatform[platform].apiPath,
      ...filterParams,
    },
  };

  // اگر مولتی پلتفرم انتخاب شده بود باید لیست پلت فرم هارو بفرستیم
  if (platform === 'multiPlatform') {
    params.params.platforms = stream.params.platforms?.map(
      (platform) => mapToApiPlatform[platform]
    );
  }

  // اگر از نوع موضوع است یا فیلتر موضوع دارد
  if (stream.type === 1 || stream.filterType === 1) {
    params.params.query = stream.params?.query || undefined;
  }

  return params;
};

export const publishRateParams = (platform) => {
  const params = {
    time_duration: 86400,
    time_gap: 'hour',
    document_inserted_at: undefined,
  };
  switch (platform) {
    case 'news':
      params.api_path = '/news/posts/publish_process';
      break;
    case 'instagram':
      params.api_path = '/instagram/posts/share_process';
      params.min_advert_noise = 0;
      params.max_advert_noise = 0.15;
      break;
    case 'telegram':
      params.api_path = '/telegram/info/process';
      params.count = 50;
      params.info = 'post_count';
      params.sort_type = 'DESC';
      break;
    case 'twitter':
      params.api_path = '/twitter/posts/tweet_process';
      params.source = 'original';
      break;
    case 'virasty':
      params.api_path = '/virasty/posts/publish_process';
      params.source = 'original';
      break;
  }

  return params;
};

export const postCountParams = (platform) => {
  const params = {
    time_duration: 86400,
    document_inserted_at: undefined,
  };
  switch (platform) {
    case 'news':
      params.api_path = '/news/info';
      break;
    case 'instagram':
      params.api_path = '/instagram/info';
      params.min_advert_noise = 0;
      params.max_advert_noise = 0.15;
      break;
    case 'telegram':
      params.api_path = '/telegram/info';
      break;
    case 'twitter':
      params.api_path = '/twitter/info';
      params.source = 'original';
      break;
    case 'virasty':
      params.api_path = '/virasty/info';
      params.source = 'original';
      break;
  }

  return params;
};
